import { render, staticRenderFns } from "./Collector.vue?vue&type=template&id=67e1ef37&scoped=true"
import script from "./Collector.vue?vue&type=script&lang=js"
export * from "./Collector.vue?vue&type=script&lang=js"
import style0 from "./Collector.vue?vue&type=style&index=0&id=67e1ef37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e1ef37",
  null
  
)

export default component.exports